import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Grid, Typography } from '@mui/material'
import { getFaq, getFaqSection } from 'redux/actions/UserFAQ';
import FaqTab from 'pages/faq/FaqTab'
import FaqQuestion from 'pages/faq/FaqQuestion';
import Header from 'components/header/Header';


function Help() {
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');
  const faqSection = useSelector((state) =>  state?.userFaqSection?.userFaqSection?.data)
  const faqSectionLoader = useSelector((state) => state?.userFaqSection?.loading);
  const faqData = useSelector((state) => state.userFaq?.userFaq?.data);
  const faqLoader = useSelector((state) => state?.userFaq?.loading);
  const [searchParams,setSearchParams] = useSearchParams();
  const isMobile = searchParams.get('isMobile') ;
  const typeValue = searchParams.get('type');
  const [value, setValue] = useState(typeValue || 'Customer');
  const referAndEarn = faqSection?.filter((data) => data.name === 'Refer & Earn')
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
      const filterData = {
        id:  referAndEarn?.[0]?.id,
        role: newValue,
      };
      dispatch(getFaq(filterData));
  };
  useEffect(() =>{
    dispatch(getFaqSection())
  },[])
  useEffect(() =>{
    if(referAndEarn){
      const filterData = {
        id: referAndEarn?.[0]?.id,
        role: value,
      };
      dispatch(getFaq(filterData));
    }  
  },[faqSectionLoader])
  return (
    <>
     {!isMobile && !token &&
    <Grid className='height86'><Header /></Grid> }
    <Grid container className={isMobile ? 'p10' : 'padding30'}>
    {!isMobile  && <Grid item container 
      justifyContent='space-between'
      >
      <Grid item className='help'>
      <Typography className='helpHeader'>Frequently Asked Questions</Typography>
      </Grid>
      <Grid item>
        {/* TODO: for future implementation */}
        {/* <SearchBar /> */}
      </Grid>
      </Grid>}
      <Grid item className='width100'>
       {(!typeValue)&&
       <FaqTab
       handleChange={handleTabChange}
       value={value}
       faqData={faqData}
       faqLoader={faqLoader}
       faqSectionLoader={faqSectionLoader}
     /> } 
     {(isMobile && typeValue) &&
     <FaqQuestion
          handleChange={handleTabChange}
          value={value}
          faqData={faqData}
          faqLoader={faqLoader}
          faqSectionLoader={faqSectionLoader}
        /> }
      </Grid>
    </Grid>
    </>
  )
}

export default Help